<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>

    <div class="box box-info">
      <form class="form-horizontal">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-3">
            <label>Cash Account</label>
            <Dropdown v-model="account" :options="cashList"
                      optionLabel="name"
                      class="dropDown"
                      :filter=true
                      placeholder="Select Account"
                      :showClear="true"
            >
            </Dropdown>

          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="fromDate">From Date</label>
            <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="fromDate"
                        v-model="fromDate"/>
          </div>
          <div class="p-field p-col-12 p-md-2 ">
            <label for="toDate">To Date</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="toDate"
                        v-model="toDate"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button @click.prevent="searchCashBook" label="Search" class="p-button p-component addNewBtn btn-btm-0"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button v-if="this.cashBookList.length > 0" @click.prevent="reset" class="p-button-raised"
                    label="Reset"/>
          </div>
       <div class="p-field p-col-12 p-md-1 p-mt-3">
          <a href="#" @click.prevent="exportCSV()" class="p-field p-col-12 p-md-12" v-if="this.cashBookList.length > 0">
            <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
          </a>
                 </div>
     <div class="p-field p-col-12 p-md-1 p-mt-3">
            <a href="#" @click.prevent="exportPDF()" v-if="this.cashBookList.length > 0">
              <img src="../../../../static/img/pdf.png" style="float: right;height: 3em;width: 3em;"/>
            </a>
          </div>
        </div>
            
      </form>
      <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
          <DataTable :value="cashBookList"
                     :paginator="true" ref="po"
                     :rows="100"
                     exportFilename="cashBook"
                     :rowsPerPageOptions="[100,500,1000]"
                     class="p-datatable-responsive p-datatable-gridlines"
                     :filters="filters"
                     data-key="id">
                     <template #header>
        <div style="text-align: left">
            <Button class="p-button p-component btn-btm-0" icon="pi pi-external-link" label="Export" @click="exportCSV1($event)" />
        </div>
    </template>
            <template #empty>No record found</template>
            <Column header="S.N">
              <template #body="sl">
                {{ sl.index + 1 }}
              </template>
            </Column>
            <Column :sortable="true" header="Miti" field="transactionDateNepali" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDateNepali']"/>
              </template>
            </Column>

            <Column :sortable="true" header="Date" field="transactionDate" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDate']"/>
              </template>

            </Column>
            <Column :sortable="true" header="Vou Type" field="moduleType" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['moduleType']"/>
              </template>

            </Column>
            <Column :sortable="true" header="Voucher" field="voucher" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['voucher']"/>
              </template>

            </Column>
            <Column :sortable="true" header="Particulars" field="accountName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
              </template>

            </Column>
            <Column :sortable="true" header="Cash In" field="debitBalance" bodyStyle="color:#00a65a;text-align: right"
                    filterMatchMode="contains">
                    <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['debitBalance']"/>
              </template>

            </Column>
            <Column :sortable="true" header="Cash Out" field="creditBalance" bodyStyle="color:#dd4b39;text-align: right"
                    filterMatchMode="contains">
                    <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['creditBalance']"/>
              </template>

            </Column>
            <Column :sortable="true" header="Balance" field="closingBalance" filterMatchMode="contains" bodyStyle="text-align: right">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['closingBalance']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Dr-Cr" field="drCr" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['drCr']"/>
              </template>
            </Column>
          </DataTable>
      </div>
        </div>
      </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'

export default {
  data() {
    return {
      loading: false,
      fromDate: null,
      toDate: null,
      cashBookList: [],
      cashList: [],
      account: null,
      accountMasterId: null,
      columnList: '',
      englishDateEnabled: true,
      filters: {}
    }
  },
  mounted() {
    this.cash()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
  },
  methods: {
    async cash() {
      let response = await this.$store.dispatch('loadCashListForDropdown')
      this.cashList = response.data.data
    },
    async searchCashBook() {
      if (this.account == null) {
        this.accountMasterId = 0
      } else {
        this.accountMasterId = this.account.id
      }
      let cashObject = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        accountId: this.accountMasterId
      }
      if (this.account == null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select account!', life: 10000})
        return
      }
      this.loading = true
      let response = await this.$store.dispatch('loadCashBook', cashObject)
      this.loading = false
      this.cashBookList = response.data.data
      if (response.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList,
        accountMasterId: this.accountMasterId
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccounting/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/cashBook' + '/' + this.$store.getters.fyId + '/' + data.columnList + '/' + data.accountMasterId + '/CB',
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'cashBook.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportPDF() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        accountMasterId: this.accountMasterId
      }
      axios({
        url: globalKey + '/fileDownload/printLedger/' + data.accountMasterId + '/accountLedger' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + this.$store.getters.fyId + '/' + data.fromDate + '/' + data.toDate,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'cashBook.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    exportCSV1() {
      this.$refs.po.exportCSV()
    },
    reset() {
      this.cashBookList = []
      this.account = null
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    }
  },
  components: {
    Dropdown,
    DatePicker,
    DataTable,
    Column,
    InputText,
    InputMask,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// cashBook.vue?54533edf